import { motion } from 'framer-motion';

function PaginaInicial() {
  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif', overflow: 'hidden', position: 'relative' }}>

      {/* Blobs de fundo */}
      <div style={{ position: 'absolute', width: 500, height: 500, backgroundColor: '#e0e7ff', borderRadius: '50%', top: -150, left: -150, filter: 'blur(100px)', opacity: 0.6 }} />
      <div style={{ position: 'absolute', width: 500, height: 500, backgroundColor: '#e0e7ff', borderRadius: '50%', bottom: -150, right: -150, filter: 'blur(100px)', opacity: 0.6 }} />

      <div style={{ position: 'relative', zIndex: 10, textAlign: 'center', padding: '0 24px', maxWidth: 600 }}>

        {/* Ícone */}
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          style={{ fontSize: '4rem', marginBottom: 24 }}
        >
          🔧
        </motion.div>

        {/* Título */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          style={{ fontSize: 'clamp(2rem, 6vw, 3rem)', fontWeight: 800, color: '#111827', marginBottom: 16 }}
        >
          Site em Manutenção
        </motion.h1>

        {/* Linha decorativa */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: 60 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          style={{ height: 4, backgroundColor: '#4f46e5', borderRadius: 4, margin: '0 auto 24px' }}
        />

        {/* Texto */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          style={{ color: '#6b7280', fontSize: '1.1rem', lineHeight: 1.8, marginBottom: 12 }}
        >
          Estamos realizando melhorias para oferecer uma experiência ainda melhor.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.65 }}
          style={{ color: '#9ca3af', fontSize: '0.95rem', lineHeight: 1.7, marginBottom: 48 }}
        >
          Em breve estaremos de volta. Agradecemos a compreensão!
        </motion.p>

        {/* Footer */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.9 }}
          style={{ color: '#d1d5db', fontSize: '0.8rem', marginTop: 32 }}
        >
          © {new Date().getFullYear()} — Todos os direitos reservados.
        </motion.p>

      </div>
    </div>
  );
}

export default PaginaInicial;